const asArray = (value) => (Array.isArray(value) ? value : []);

/** Single display string for doctor / hospital — avoids "Dr. Dr. Name" when API already prefixes. */
export function displayProviderName(role, rawName) {
  const roleStr = String(role || "").toLowerCase();
  const trimmed = String(rawName || "").trim() || "Provider";
  if (roleStr === "doctor") {
    const base = trimmed.replace(/^(dr\.?\s+|doctor\s+)/i, "").trim() || trimmed;
    return `Dr. ${base}`;
  }
  return trimmed;
}

/**
 * Normalizes GET /app/appointments (or similar) payload to a list of row objects.
 */
export function normalizePatientAppointments(payload) {
  const source = payload?.data || payload || {};
  return asArray(source?.items).map((item) => ({
    id: item?._id || item?.id || "",
    bidLogId: item?.bidLogId || "",
    providerRole: String(item?.providerRole || "doctor"),
    providerName: item?.providerName || "Provider",
    status: String(item?.status || "pending_approval"),
    appointmentDate: item?.appointmentDate || "",
    timeSlot: item?.timeSlot || "",
    clinicName: String(item?.clinicName || "").trim(),
    clinicPhone: String(item?.clinicPhone || "").trim(),
    clinicAddress: String(item?.clinicAddress || "").trim(),
    clinicLatitude: item?.clinicLatitude ?? null,
    clinicLongitude: item?.clinicLongitude ?? null,
    noteForDoctor: item?.noteForDoctor || "",
    doctorAction: item?.doctorAction || "",
    proposalSource: item?.proposalSource || "",
    doctorProposedDate: item?.doctorProposedDate || "",
    doctorProposedTimeSlot: item?.doctorProposedTimeSlot || "",
    visitOutcomeAt: item?.visitOutcomeAt ?? null,
    visitPatientAttended: item?.visitPatientAttended ?? null,
    visitProcedureProceeding: item?.visitProcedureProceeding ?? null,
    visitBookedPriceInr: item?.visitBookedPriceInr ?? null,
    visitSamePriceAsBooked: item?.visitSamePriceAsBooked ?? null,
    visitFinalAgreedPriceInr: item?.visitFinalAgreedPriceInr ?? null,
    visitPriceChangeReason: item?.visitPriceChangeReason || "",
  }));
}
